import { INIT_ROOT, UPDATE_AUTH_TOKEN } from '../actionTypes';

export default (state, { type, payload }) => {
  if (type === INIT_ROOT) {
    return {
      enabled: payload.authEnabled,
      authRedirectUrl: payload.authRedirectUrl,
      token: payload.token
    };
  }
  if (type === UPDATE_AUTH_TOKEN) {
    return Object.assign({}, state, { token: payload });
  }
  return state || { enabled: false, token: null };
};
